module.exports = __webpack_public_path__ + "static/DarksideDetective7-1f07298787bb70379898543a44e93bf5.png";